import { render, staticRenderFns } from "./addadvertising.vue?vue&type=template&id=7b8513eb&"
import script from "./addadvertising.vue?vue&type=script&lang=js&"
export * from "./addadvertising.vue?vue&type=script&lang=js&"
import style0 from "./addadvertising.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8513eb')) {
      api.createRecord('7b8513eb', component.options)
    } else {
      api.reload('7b8513eb', component.options)
    }
    module.hot.accept("./addadvertising.vue?vue&type=template&id=7b8513eb&", function () {
      api.rerender('7b8513eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/components/addadvertising.vue"
export default component.exports